// extracted by mini-css-extract-plugin
module.exports = {"withdrawPage__container":"withdrawPage_withdrawPage__container__mHwWw","withdrawPage__title":"withdrawPage_withdrawPage__title__59vqX"};